import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import Map, { Source, Layer, Marker, Popup, NavigationControl } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import axios from "axios";
import { URL_BASE } from "../../config/url-server";
import { Divider, Spin } from "antd";
import config from "../../config/config"; // Aquí debe estar tu token de Mapbox
import { Link } from "react-router-dom";
import lotService from "../../services/lot-service";
import { toast, ToastContainer } from "react-toastify";

const MapLot = () => {

     const { lotId } = useParams();
    const [title, setTitle] = useState("Finca - Lote");

    const [viewState, setViewState] = useState({
        latitude: 5.391078, // Se actualizará dinámicamente
        longitude: -73.869958, // Se actualizará dinámicamente
        zoom: 5, // Zoom inicial
    });


    //juancpinedam.7rb27w8d

    const [selectedPoint, setSelectedPoint] = useState(null); // Punto seleccionado para el popup
    const [lotPalmsLayer, setLotPalmsLayer] = useState(null);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [centerMap, setCenterMap] = useState({ lat: 10.5582, lng: -74.1915 });
    const [markerData, setMarkerData] = useState([]);
    const [popupInfo, setPopupInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tileset, setTileset] = useState(null);

    const clientId = localStorage.getItem("client");
    const accessToken = localStorage.getItem("token");

    const loadLotPositions = async () => {
        try {
            
            const params = { lotId };
            const configAxios = {
                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`,
                },
                params,
            };

            const response = await axios.get(URL_BASE + "map/map-lot", configAxios);
            const lot_name = response.data.lotName;
            const farm_name = response.data.farmName;
            setTitle(`${farm_name} -  ${lot_name}`)
            const palms = response.data.data;
            const tilesetWeb = response.data.tileset;
            setTileset(tilesetWeb)


            if (palms.length > 0) {
                const middle = Math.floor(palms.length / 2);
                const coords = palms[middle]?.location?.coordinates;

                if (coords && coords.length === 2) {
                    const lat = coords[1];
                    const lng = coords[0];
                    setCenterMap({ lat, lng });

                    setViewState({
                        latitude: lat,
                        longitude: lng,
                        zoom: 18,
                    });
                }


            }

            setMarkerData(palms);

            console.log("palms", palms)




            const filterCoord = palms.map((location, index) => {
                const [lng, lat] = location.location.coordinates;
                const name = `${location.lineName}-${location.palmName}`;

                return (
                    <Marker
                        key={`lot-palm-${index}`}
                        longitude={lng}
                        latitude={lat}
                        anchor="center"
                    >
                        <div
                            onClick={() => {
                                console.log(location)
                                setSelectedPoint(location)
                            }
                            }
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "white",
                                border: `2px solid #000`,
                                padding: "2px 4px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontSize: "10px",
                                color: "#000",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                            }}
                            title={name}
                        >
                            {name}
                        </div>
                    </Marker>
                );
            });




            setLotPalmsLayer(filterCoord)





        } catch (error) {
            console.error("Error obteniendo las palmas:", error);
        } finally {
            setLoading(false);
        }
    };


    const isValidCoordinate = (coord) => {


        return (
            Array.isArray(coord) &&
            coord.length === 2 &&
            typeof coord[0] === 'number' &&
            typeof coord[1] === 'number' &&
            !isNaN(coord[0]) &&
            !isNaN(coord[1])
        );
    };



    const centrarMapa = async (latitude, longitude) => {
        const params = { id: lotId, latitude, longitude };
        const response = await lotService.updateCenter(params)
        toast.success("Realizado", { autoClose: 1600 })
        setSelectedPoint(null)
    }



    useEffect(() => {
        loadLotPositions();
    }, []);

    return (
        <div >
            <ToastContainer />
            <div className="col-12 " style={{ marginTop: "-10px" }}>
                <Divider orientation="left" style={{ border: "#AAAAAA" }} >

                    <Link to="/admin-lots" className="nav-link link-primary p-1">
                        <i className="bi bi-arrow-left-short fa-lg"></i>
                        <span className="fs-6 m-1">
                            <strong>REGRESAR</strong>
                            <label className="text-secondary ms-3">  MAPA - {title} </label>
                        </span>
                    </Link>
                </Divider>
            </div>


            <Map
                {...viewState} // Aplicar el estado de la vista dinámica
                onMove={evt => setViewState(evt.viewState)} // Permitir mover el mapa
                style={{ width: "100%", height: "100vh" }}
                mapStyle="mapbox://styles/mapbox/satellite-v9" // Mapa satelital
                mapboxAccessToken="pk.eyJ1IjoianVhbmNwaW5lZGFtIiwiYSI6ImNtNXlyNmxtbjBubm0ya3B5ZHVnMWgwcWYifQ.dogzl3DX9PMO9QywZ8CbyA"
            >

                <NavigationControl position="top-left" />

                {lotPalmsLayer}


                {selectedPoint && selectedPoint.location?.coordinates && (
                    <Popup
                        longitude={selectedPoint.location.coordinates[0]}
                        latitude={selectedPoint.location.coordinates[1]}
                        onClose={() => setSelectedPoint(null)}
                        closeOnClick={false}
                    >
                        <div>

                            <p className="text-success" ><strong>Linea-Palma</strong></p>
                            <hr></hr>
                            <strong>Línea:</strong> {selectedPoint.lineName || "N/A"}<br />
                            <strong>Palma:</strong> {selectedPoint.palmName || "N/A"}<br />
                            <strong>Latitud:</strong> {selectedPoint.location.coordinates[1] || "N/A"}<br />
                            <strong>Longitud:</strong> {selectedPoint.location.coordinates[0] || "N/A"}
                            <hr></hr>
                            <button onClick={() => centrarMapa(selectedPoint.location.coordinates[1], selectedPoint.location.coordinates[0])} className="btn-primary text-white mt-2 w-100">Centrar lote acá</button>
                        </div>
                    </Popup>
                )}

                {tileset && (
                    <>
                        <Source
                            id="ortomosaico"
                            type="raster"
                            url={`mapbox://${tileset}`}
                            tileSize={256}
                        />
                        <Layer
                            id="ortomosaico-layer"
                            type="raster"
                            source="ortomosaico"
                            paint={{ "raster-opacity": 1 }}
                        />
                    </>
                )}
            </Map>

        </div>
    );
};

export default MapLot;
